import React from 'react';
import PageButton from '../../elements/PageButton/PageButton';
import {getLeagueByRating} from '../../../utils/rating/getLeagueByRating';
import {getPlaceIconPath} from '../../../utils/gameEnd/getPlaceIconPath';
import {resolveDailyRatingCrystals} from '../../../utils/rating/resolveDailyRatingCrystals';
import {GLORY_HALL_REWARDED_PLACES} from '../../../configs/ratingCrystals';
import AiPlayerMark from '../../VisibleBotMark/AiPlayerMark';

/**
 * Плашка игрока в Зале славы. Одна и та же и в списке, и над списком (там
 * показывается сам игрок, если он не попал на текущую страницу).
 *
 * Вторая строка «Доход» появляется у тех, кому в конце игрового дня реально
 * что-то начислят: за лигу (золото и выше) и/или за место в тройке. Считает
 * ровно тот же resolveDailyRatingCrystals, по которому начисляет сервер.
 */
export const GloryHallUserItem = ({user, isCurrentUser, onClick, pageId, buttonId}) => {
  const league = getLeagueByRating(user.rating);
  const placeIcon = user.rank <= GLORY_HALL_REWARDED_PLACES ? getPlaceIconPath(user.rank - 1) : null;
  const {crystals} = resolveDailyRatingCrystals({
    rating: user.rating,
    gloryPlace: user.rank <= GLORY_HALL_REWARDED_PLACES ? user.rank : null,
  });

  return (
    <PageButton
      className={`glory-hall-user-item${isCurrentUser ? ' glory-hall-user-item_current-user' : ''}`}
      onClick={onClick}
      pageId={pageId}
      buttonId={buttonId}
    >
      <span className={'glory-hall-user-main-row'}>
        {placeIcon ? (
          <img
            className={'glory-hall-user-place-icon'}
            src={placeIcon}
            alt={`${user.rank} место`}
          />
        ) : (
          // Ниже тройки медалей нет — просто номер места в том же месте плашки
          <span className={'glory-hall-user-place-icon glory-hall-user-place-number'}>
            {user.rank}
          </span>
        )}
        <span className={'glory-hall-user-name'}>
          {user.name}
          {/* ИИ-игрок промо-матча — полноценный участник рейтинга, но с меткой */}
          {user.isAi && <AiPlayerMark/>}
        </span>
        <span className={'glory-hall-user-battles'}>
          <img
            className={'glory-hall-user-battles-icon'}
            src={'/img/icons/barracks white.png'}
            alt={'Рейтинговые битвы'}
            title={'Рейтинговые битвы'}
          />
          {user.rankedGamesPlayed}
        </span>
        <span className={'glory-hall-user-rating text-rating'}>{user.rating}</span>
        <img
          className={'glory-hall-user-league-icon'}
          src={league.iconPath}
          alt={league.name}
          title={league.name}
        />
      </span>

      {crystals > 0 && (
        <span className={'glory-hall-user-income'}>
          Доход <span className={'text-crystals'}>+{crystals}</span>
          <img
            className={'glory-hall-user-income-icon'}
            src={'/img/icons/crystal.png'}
            alt={'Кристаллы'}
          />
          / день
        </span>
      )}
    </PageButton>
  );
};

export default GloryHallUserItem;
